<template>
  <div>
    <div>
      <div class="flex flex-row flex-wrap justify-between px-4 py-3">
        <SearchBar
          class="w-80"
          placeholder="Search by image title, skus and tags"
          v-on:handleInput="handleInput"
        />

        <div>
          <button
            @click="() => (syncConfirm = true)"
            class="mr-2 bg-amber-500 text-white active:bg-amber-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
          >
            ↓ Sync
          </button>
          <button
            @click="() => (createModalOpen = true)"
            class="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
          >
            + Add
          </button>
        </div>
      </div>
      <div class="flex flex-col">
        <div class="overflow-x-auto">
          <table class="items-center w-full bg-transparent border-collapse">
            <ImageTableHead :order="order" />
            <tbody>
              <ImageItemRow
                v-for="image in fbFilteredImages.slice(this.from, this.to)"
                :key="image.id"
                :image="image"
                v-on:imageEdit="imageEdit"
                v-on:imageDelete="imageDelete"
              />
            </tbody>
          </table>
        </div>
        <TableNavigation
          class="rounded-b-md"
          :from="from + 1"
          :to="to"
          :total="fbFilteredImages.length"
          :navigate="navigate"
          :itemPerPage="itemPerPage"
          @update:itemPerPage="handleChangeItemNumber"
        />
      </div>
    </div>
    <ImageCreateModal
      :handleClose="() => (createModalOpen = false)"
      :isOpen="createModalOpen"
    />
    <ImageEditModal
      :handleClose="() => (editModalOpen = false)"
      :isOpen="editModalOpen"
      :image="editModalData"
    />
    <STLDeleteConfirmation
      :handleClose="() => (delConfirm = false)"
      :isOpen="delConfirm"
      :handleDelete="handleDelete"
      :item="deleteModalData"
    />
    <STLSyncConfirmation
      :handleClose="() => (syncConfirm = false)"
      :isOpen="syncConfirm"
      :isSyncing="syncLoading"
      :handleSync="handleSync"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import * as Actions from "@/store/actions.type";
import SearchBar from "@/components/Shared/Input/SearchBar";
import ImageTableHead from "@/components/ComponentModule/ShopTheLook/View/ImageTableHead";
import ImageItemRow from "@/components/ComponentModule/ShopTheLook/View/ImageItemRow";
import TableNavigation from "@/components/Shared/Table/TableNavigation";
import ImageCreateModal from "@/components/ComponentModule/ShopTheLook/Create/ImageCreateModal";
import ImageEditModal from "@/components/ComponentModule/ShopTheLook/Edit/ImageEditModal";
import STLDeleteConfirmation from "@/components/ComponentModule/ShopTheLook/Form/STLDeleteConfirmation";
import STLSyncConfirmation from "@/components/ComponentModule/ShopTheLook/Form/STLSyncConfirmation";
import { httpsCallable } from "firebase/functions";
import { firebaseFunctions } from "@/common/firebase";
import settings from "@/common/config";

export default {
  name: "ImageInfoSection",
  components: {
    SearchBar,
    ImageTableHead,
    ImageItemRow,
    TableNavigation,
    ImageCreateModal,
    ImageEditModal,
    STLDeleteConfirmation,
    STLSyncConfirmation
  },
  data() {
    return {
      page: 0,
      toggle: false,
      createModalOpen: false,
      editModalOpen: false,
      delConfirm: false,
      syncConfirm: false,
      syncLoading: 0,
      editModalData: {},
      deleteModalData: {},
      itemPerPage: 10
    };
  },
  computed: {
    from() {
      return this.page * this.itemPerPage;
    },
    to() {
      if ((this.page + 1) * this.itemPerPage < this.fbFilteredImages.length) {
        return this.from + this.itemPerPage;
      } else {
        return this.fbFilteredImages.length;
      }
    },
    ...mapGetters(["fbFilteredImages"])
  },
  watch: {
    fbFilteredImages() {
      this.page = 0;
    },
    itemPerPage() {
      this.page = 0;
    }
  },
  methods: {
    navigate(step) {
      if (step === "prev" && this.page !== 0) {
        this.page -= 1;
      }
      if (
        step === "next" &&
        (this.page + 1) * this.itemPerPage < this.fbFilteredImages.length
      ) {
        this.page += 1;
      }
    },
    imageEdit(image) {
      this.editModalOpen = true;
      this.editModalData = image;
    },
    imageDelete: function (image) {
      this.delConfirm = true;
      this.deleteModalData = image;
    },
    handleDelete(image) {
      this.$store
        .dispatch(Actions.FB_DELETE_IMAGE, {
          region: "au",
          id: image.id
        })
        .then(() =>
          setTimeout(() => {
            this.delConfirm = false;
          }, 900)
        );
    },
    handleChangeItemNumber(val) {
      this.itemPerPage = val;
    },
    handleSync() {
      var syncImageFile = httpsCallable(
        firebaseFunctions,
        settings.AU_STL_FUNCTIONS_IMAGE
      );
      this.syncLoading = 1;
      syncImageFile("").then(() => {
        this.syncLoading = 2;
        setTimeout(() => {
          this.syncConfirm = false;
          this.syncLoading = 0;
        }, 500);
      });
    },
    handleInput(value) {
      this.$store.dispatch(Actions.FB_SEARCH_IMAGE, value);
    },
    order(param) {
      this.$store.dispatch(Actions.FB_ORDER_IMAGE, {
        param,
        toggle: this.toggle
      });
      this.toggle = !this.toggle;
    }
  }
};
</script>
